import { render, staticRenderFns } from "./ProxyPane.vue?vue&type=template&id=45b01508&scoped=true"
import script from "./ProxyPane.vue?vue&type=script&lang=js"
export * from "./ProxyPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b01508",
  null
  
)

export default component.exports